module.exports = __webpack_public_path__ + "a2a5216cb2592c3ff774542bfbf4a3f7.png";